module.exports = __webpack_public_path__ + "static/media/mangaa_logo.8851ea56.png";